export const LOGO_1 = "https://customer-assets.emergentagent.com/job_medform-standby/artifacts/3xn9wu25_standby_transparent.png";
export const LOGO_2 = "https://customer-assets.emergentagent.com/job_medform-standby/artifacts/v4idzbss_on_site_transparent.png";

export const TAG_COLORS = [
  { value: 'Green', label: 'Green (Minor)', className: 'bg-green-500 text-white border-green-600' },
  { value: 'Yellow', label: 'Yellow (Delayed)', className: 'bg-yellow-400 text-black border-yellow-500' },
  { value: 'Orange', label: 'Orange (Urgent)', className: 'bg-orange-500 text-white border-orange-600' },
  { value: 'Red', label: 'Red (Immediate)', className: 'bg-red-600 text-white border-red-700' },
  { value: 'Black', label: 'Black (Deceased)', className: 'bg-black text-white border-gray-900' },
];

export const HIPAA_TEXT = `I understand that the information I provide on this form may include protected health information (PHI) as defined by the Health Insurance Portability and Accountability Act of 1996 (HIPAA). This information will be used and disclosed solely for the purposes of treatment, payment, and healthcare operations, as permitted by law.

I acknowledge that my health information may be shared with authorized personnel, healthcare providers, and affiliated organizations as necessary to ensure proper care and coordination of services. All reasonable efforts will be made to safeguard my information in accordance with applicable federal and state privacy regulations.

I understand that I have the right to request restrictions on the use and disclosure of my health information, to inspect and obtain a copy of my records, and to revoke this authorization in writing at any time, except to the extent that action has already been taken in reliance on it.

By signing below, I acknowledge that I have read and understand this HIPAA disclaimer and consent to the use and disclosure of my protected health information as described above.`;

export const RMA_TEXT = `I, the undersigned, acknowledge that I have been evaluated by emergency medical personnel and have been offered medical care and/or transportation to a hospital or other medical facility.

I understand that by refusing medical treatment and/or transport, I may be placing my health and well-being at risk. The potential risks of refusal have been explained to me, including but not limited to worsening of my condition, permanent disability, or death.

If I am accepting transport, I acknowledge that I am choosing the destination and understand that medical care during transport is limited to the capabilities of the responding personnel and equipment.

I affirm that I am of sound mind, not under the influence of drugs or alcohol to the extent that it impairs my judgment, and am able to make informed decisions regarding my care. I understand that I may seek medical attention at any time and have been advised to call 911 or seek immediate care if my condition worsens.

By signing below, I release and hold harmless the responding agency, its members, and affiliates from any liability arising from my decision to refuse care and/or transport, or from my decisions regarding my medical care.

I acknowledge that I have read and fully understand this disclaimer and accept full responsibility for my health and well-being.`;

export const INITIAL_VITAL_SIGNS = { time: '', pulse: '', blood_pressure: '', respiration: '', o2_saturation: '', ctc: '' };

export const INITIAL_PMH = {
  asthma: false, diabetes: false, cardiac: false, hypertension: false,
  copd: false, emphysema: false, psychiatric: false, other: '',
  none: false, unable_to_obtain: false
};

export const INITIAL_FORM_DATA = {
  first_name: '', last_name: '', gender: '', address: '', tel: '', dob: '',
  reason_for_treatment: '', tag_color: '', objective_assessment: '',
  allergies: '', allergies_nka: false, allergies_unable: false,
  medication: '', medication_none: false, medication_unable: false,
  past_medical_history: { ...INITIAL_PMH },
  vital_signs_1: { ...INITIAL_VITAL_SIGNS },
  vital_signs_2: { ...INITIAL_VITAL_SIGNS },
  vital_signs_3: { ...INITIAL_VITAL_SIGNS },
  vital_signs_4: { ...INITIAL_VITAL_SIGNS },
  vitals_na: false,
  physical_assessment: '',
  is_transported: false, transported_by: '',
  hipaa_signature: '', hipaa_signature_status: '', hipaa_date: '',
  hipaa_guardian_name: '', hipaa_guardian_signature: '',
  hipaa_authorized_name: '', hipaa_authorized_relation: '',
  rma_signature: '', rma_signature_status: '', rma_date: '',
  rma_guardian_name: '', rma_guardian_signature: '',
  rma_authorized_name: '', rma_authorized_relation: '',
  provider_signature: '', provider_name: '', provider_certification: '',
  event_location: '', event_name: '', triage_center: '', form_date: '', patient_contact_time: ''
};

export const OTC_MEDICATION_TEXT = `ON SITE MEDICAL CONSULTANTS LLC (OSMC)
Over-the-Counter (OTC) Medication Acknowledgment and Release of Liability

I acknowledge that I have voluntarily requested and received an over-the-counter (OTC) medication from On Site Medical Consultants LLC (OSMC).

By electronically signing this form, I certify and acknowledge that:

I am not allergic to, and have no known hypersensitivity to, the medication provided, including any of its active or inactive ingredients.
I specifically affirm that I am not allergic to:
Aspirin (ASA)
Acetaminophen (Tylenol®)
Ibuprofen (Advil®/Motrin®)
Any ingredients contained within these medications.
I have read and understand the medication label, including its intended use, dosage instructions, warnings, precautions, and potential side effects.
The medication is being provided by OSMC for my self-administration. The medication is not being administered by OSMC personnel, and I am solely responsible for determining whether I should take the medication and for taking it in accordance with the manufacturer's instructions.
OSMC personnel are not acting as my physician and are not providing medical advice regarding whether I should take the medication. I understand that if I have questions regarding the appropriateness of the medication, I should consult with my personal physician or healthcare provider.
I understand that adverse reactions, side effects, allergic reactions, drug interactions, or other complications may occur with any medication, including over-the-counter medications.
In consideration of receiving the medication, I voluntarily release, indemnify, and hold harmless On Site Medical Consultants LLC (OSMC), its Medical Director, employees, EMTs, paramedics, nurses, contractors, agents, affiliates, event organizers, venue owners, and representatives from any and all claims, liabilities, damages, losses, injuries, or causes of action arising out of or related to my voluntary use of the medication provided.
I acknowledge that I have had the opportunity to decline the medication and that I accept full responsibility for my decision to take the medication.

By selecting "I Agree" and electronically signing this form, I acknowledge that I have read, understand, and voluntarily agree to the terms contained herein.`;

export const OTC_MEDICATIONS = [
  { value: 'aspirin', label: 'Aspirin (ASA)' },
  { value: 'tylenol', label: 'Tylenol (Acetaminophen)' },
  { value: 'motrin', label: 'Motrin (Ibuprofen)' },
  { value: 'advil', label: 'Advil (Ibuprofen)' },
];

export const TREATMENT_REASONS = [
  'Medical',
  'Trauma',
  'Drug Usage',
  'ETOH',
  'Sick',
  'Chest Pains',
  'Unconscious',
];
